export default "__VITE_ASSET__DaD$pMRU__"